import { AnimatePresence, motion } from "framer-motion";
import { CaretLeftIcon } from "@phosphor-icons/react";

interface SwipeBackIndicatorProps {
  isVisible: boolean;
  progress: number; // 0 to 1
}

export function SwipeBackIndicator({ isVisible, progress }: SwipeBackIndicatorProps) {
  // Calculate opacity and scale based on progress
  const opacity = Math.min(progress * 2, 1);
  const scale = 0.8 + progress * 0.2;
  const translateX = -20 + progress * 20;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{
            opacity,
            scale,
            x: translateX,
          }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.15 }}
          className="pointer-events-none fixed top-1/2 left-4 z-[9999] -translate-y-1/2"
          style={{
            willChange: "transform, opacity",
          }}
        >
          <div
            className="bg-default-100/80 flex h-12 w-12 items-center justify-center rounded-full shadow-lg backdrop-blur-md"
            style={{
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            <CaretLeftIcon size={24} weight="bold" className="text-default-700" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
